import { render, staticRenderFns } from "./chooseProdDialog.vue?vue&type=template&id=0a902b2c&scoped=true"
import script from "./chooseProdDialog.vue?vue&type=script&lang=js"
export * from "./chooseProdDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a902b2c",
  null
  
)

export default component.exports